/* eslint-disable react/prop-types */
/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Card Skeleton
 *
 * @file CardSkeleton.jsx
 * @author Gladson Samuel S
 */

import React, { Fragment } from 'react';
import Skeleton from '@material-ui/lab/Skeleton';
import useSkeletonStyles from './styles/SkeletonStyles';

const CardSkeleton = (props) => {
  const classes = useSkeletonStyles(props);

  return (
    <div className={classes.card}>
      <Skeleton
        className={classes.cardTitle}
        variant="text"
      />

      <Skeleton
        className={classes.cardContent}
        variant="rect"
      />
    </div>
  );
};

const DashboardCardSkeleton = (props) => {
  const classes = useSkeletonStyles(props);

  return (
    <Fragment>
      <div className={classes.container}>
        <div className={classes.header}>
          <Skeleton className={classes.dashboardCardTitle} variant="text" />
        </div>
      </div>
      <div className={classes.content}>
        {props.children}
      </div>
    </Fragment>
  );
};

const ListSkeleton = (props) => {
  const classes = useSkeletonStyles(props);
  const { length = 8 } = props;

  return (
    <div className={classes.list}>
      {Array.from({ length }).map((_, index) => (
        <div className={classes.listItem} key={index}>
          <div className={classes.listItemContent}>
            <Skeleton key={index} className={classes.listItemAvatar} variant="circle" />
            <Skeleton key={index} className={classes.listItemTitle} variant="text" />
          </div>
          <Skeleton key={index} className={classes.listItemBadge} variant="text" />
          <Skeleton key={index} className={classes.listItemProgress} variant="text" />
        </div>
      ))}
    </div>
  );
};

export {
  CardSkeleton,
  DashboardCardSkeleton,
  ListSkeleton
};
